import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GlobalBannerError } from 'layouts/error-banner/model/error-banner';

export interface ErrorBannerState {
    banner: GlobalBannerError | null;
}

const initialState: ErrorBannerState = {
    banner: null,
};

const banner = createSlice({
    name: 'errorBanner',
    initialState,
    reducers: {
        setErrorBanner(state: ErrorBannerState, { payload }: PayloadAction<GlobalBannerError | null>): void {
            state.banner = payload ?? null;
        },
    },
});

export const { setErrorBanner } = banner.actions;

export default banner.reducer;
